<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'"
  [@WindowShrink]="eqSwitch ? 'normal' : 'shrinked'" (click)="windowClick()" style="max-width: 400px;"
  fxLayout="column">
  <dialog-header [label]="'Audio For Sensor: ' + sensorId" [dialogRef]='dialogRef' [object]='this'
    [autoClose]="true"></dialog-header>
  <div>
    <app-soundplayer #PlayerComp (EqClicked)="EqSwitch()" (NewSource)="connectToEq($event)"
      [Player]="AudioPlayer"></app-soundplayer>
    <!-- <div id="container"></div> -->
    <div id="container" style="position: relative; width: 100%; height: 100%;">
      <canvas #spectrogramCanvas
        [style.display]="EqPresetIndex === 1 ? 'block' : 'none'"
        style="position: absolute; top: 0; left: 0;  width: 100%; height: 100%; background: #000;">
      </canvas>
    </div>
  </div>
  <div fxLayout="row">
    <button fxFlex="none" mat-icon-button (click)="changeEqPreset(-1)" [matTooltip]="'Previus'">
      <mat-icon>navigate_before</mat-icon>
    </button>
    <div fxFlex class="textcontainer">{{EqPresetIndex + "/" + MaxEqPresets}}</div>
    <button mat-icon-button (click)="changeEqPreset(1)" [matTooltip]="'Next'">
      <mat-icon>navigate_next</mat-icon>
    </button>
  </div>
</div>

<!-- <audio #Player (ended)="AudioPlayerComp.onEnded()" preload="auto"></audio> -->